// extracted by mini-css-extract-plugin
export default {"button":"tabs_button__OjmPI","activeTab":"tabs_activeTab__A9m+J","tab_btn":"tabs_tab_btn__fRKRZ","buttonContainer":"tabs_buttonContainer__Et2Cv"};